import logo from './logo.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';
import { AuthProvider } from "./contexts/AuthContext";
import { BrowserRouter } from 'react-router-dom';
import ToastProvider from './providers/ToastProvider';
import AppRoutes from './routes/AppRoutes';
import  "./assets/css/media-query.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
      <ToastProvider>
        <AppRoutes />
      </ToastProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
